export default "__VITE_ASSET__Dat0ZkXu__"